import { JRCModalLayout } from '../JRCModalLayout';
import { JRCModalContent } from '../JRCModalContent';
import React from 'react';
import { JRCModalProps } from './JRCModal.types';

export const JRCModal = ({
    children,
    open,
    closeHandler,
    buttons,
    title,
    options,
    portalId,
    inPlace,
    ref,
    zIndex,
    enableClickAwayCloseModal = true,
    variant,
}: JRCModalProps) => {
    return (
        <JRCModalLayout
            open={open}
            closeHandler={closeHandler}
            portalId={portalId}
            inPlace={inPlace}
            zIndex={zIndex}
            ref={ref}
            variant={variant}
            enableClickAwayCloseModal={enableClickAwayCloseModal}>
            <JRCModalContent onClickIconClose={closeHandler} buttons={buttons} title={title} options={options}>
                {children}
            </JRCModalContent>
        </JRCModalLayout>
    );
};
